export const ROUTES = {
  home: '/',
  register: '/register',
  voucherLookup: '/bonos/consulta',
  birthdays: '/birthdays',
  terms: '/terms',
  restriction: '/restriction',
  login: '/login',
  cookiesPolicy: '/cookies/terms',
  legalNotice: '/legal-notice',
  privacyPolicy: '/privacy-policy',
  admin: '/admin',
  adminCustomers: '/admin/clientes',
  adminVoucherList: '/admin/bonos',
  adminVoucherCreate: '/admin/bonos/crear',
  adminVoucherRedeem: '/admin/bonos/canjear',
  adminVoucherDetail: '/admin/bonos/:voucherId',
  adminProfile: '/admin/perfil',
  adminUsers: '/admin/usuarios',
};
